"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Dashboard = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var Dashboard = function Dashboard() {
  return react_1.default.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11 2.333v5.334C11 8.403 10.384 9 9.625 9h-7.25C1.615 9 1 8.403 1 7.667V2.333C1 1.597 1.616 1 2.375 1h7.25C10.385 1 11 1.597 11 2.333zM9.75 11h-7.5C1.56 11 1 11.582 1 12.3v9.4c0 .718.56 1.3 1.25 1.3h7.5c.69 0 1.25-.582 1.25-1.3v-9.4c0-.718-.56-1.3-1.25-1.3zM21.75 15h-7.5c-.69 0-1.25.522-1.25 1.167v5.666c0 .645.56 1.167 1.25 1.167h7.5c.69 0 1.25-.522 1.25-1.167v-5.666c0-.645-.56-1.167-1.25-1.167zM21.75 1h-7.5C13.56 1 13 1.537 13 2.2v9.6c0 .663.56 1.2 1.25 1.2h7.5c.69 0 1.25-.537 1.25-1.2V2.2c0-.663-.56-1.2-1.25-1.2z",
    clipRule: "evenodd"
  });
};

exports.Dashboard = Dashboard;